import Vue from 'vue'
import VueRouter from 'vue-router'
import { getIsAdminFromSession } from '@/utils/auth'
Vue.use(VueRouter)

const routes = [
  {
    path: '/totalView',
    name: 'home-page',
    component: () => import(/* webpackChunkName: "page-total-view" */ '../views/totalView.vue'),
  },
  {
    path: '/DatabaseView',
    name: 'DatabaseView',
    component: () => import('../views/DatabaseView.vue'),
    props: { MachineLearnViewActive: true },
    meta: {
      requiresAuth: true,
      service: 'db'

    },
  },
  {
    path: '/Machinelearnview',
    name: 'Machinelearnview',
    component: () => import('../views/Machinelearnview/Machinelearnview.vue'),
    props: { MachineLearnViewActive: true },
    meta: {
      requiresAuth: true,
      service: 'ml'
    },
  },
  {
    path: '/FlavordifferView',
    name: 'FlavordifferView',
    component: () => import('../views/FlavordifferView.vue'),
  },
  {
    path: '/',
    redirect: '/totalView'
  },
  {
    path: '/Loginview',
    name: 'Loginview',
    component: () => import(/* webpackChunkName: "page-login" */ '@/views/login/Loginview.vue'),
    props: (route) => ({
      serviceType: route.query.service || 'db'
    })
  },
  {
    path: '/adminView',
    name: 'AdminView',
    component: () => import(/* webpackChunkName: "page-admin" */ '@/views/AdminView/AdminView.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    }
  },
  {
    path: '/SignView',
    name: 'SignView',
    component: () => import(/* webpackChunkName: "page-sign" */ '@/views/login/SignView.vue')
  },
  {
    path: '/ForgotPasswordView',
    name: 'ForgotPasswordView',
    component: () => import(/* webpackChunkName: "page-forgot-password" */ '@/views/login/ForgotPasswordView.vue')
  },
  {
    path: '/purchaseView',
    name: 'purchaseView',
    component: () => import(/* webpackChunkName: "page-purchase" */ '@/views/purchaseView/purchaseView.vue')
  },
  {
    path: '/purchase2View',
    name: 'purchase2View',
    component: () => import(/* webpackChunkName: "page-purchase-2" */ '@/views/purchaseView/purchase2View.vue')
  },

  {
    path: '/admin/user-records',
    name: 'AdminUserRecordManagement',
    component: () => import(/* webpackChunkName: "page-admin-records" */ '@/views/AdminUserRecordManagement/AdminUserRecordManagement.vue'),
    meta: {
      requiresAuth: true,
      isAdmin: true
    }
  }
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
});
router.beforeEach((to, from, next) => {
  //登录页直接放行，防止死循环  
  if (to.path === '/Loginview') {
    return next();
  }

  // 不需要登录的页面直接放行
  if (!to.meta.requiresAuth) {
    return next();
  }

  try {
    //  加 try/catch，防止 JSON 解析崩溃 
    const userStr = sessionStorage.getItem('user');
    const user = userStr ? JSON.parse(userStr) : null;
    const routeService = to.meta.service;

    // 未登录 → 跳登录
    if (!user) {
      const targetService = routeService || 'db';
      return next({
        path: '/Loginview',
        query: { redirect: to.fullPath, service: targetService }
      });
    }

    // 已登录 → 校验服务权限
    if (routeService) {
      const hasServicePermission = sessionStorage.getItem(`loginService_${routeService}`) === 'true';
      
      if (!hasServicePermission) {
        if (from.path !== '/Loginview') {
          Vue.prototype.$message.error(`请登录${routeService === 'db' ? '数据库' : '机器学习'}`);
        }
        return next({
          path: '/Loginview',
          query: { redirect: to.fullPath, service: routeService }
        });
      }
    }

    // 已登录 → 校验管理员权限
    if (to.meta.requiresAdmin || to.meta.isAdmin) {
      if (!getIsAdminFromSession()) {
        Vue.prototype.$message.error('您没有管理员权限');
        return next({ path: '/totalView' });
      }
    }

    // 所有校验通过
    next();

  } catch (err) {
    // 存储异常 → 清空缓存，强制重新登录
    console.error('路由权限校验异常：', err);
    sessionStorage.clear();
    next('/Loginview');
  }
});

export default router;